import {z} from '@hono/zod-openapi';

export const serviceCampaignPathSchema = z
  .object({
    serviceCaseId: z.string().uuid().openapi({example: '40b47967-97a9-4206-a3ea-d8656c97dd77'}),
  })
  .openapi('ServiceCampaignPath');
